'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowInitialMessage = undefined;

var _reselect = require('reselect');

var _getIsOpen = require('./getIsOpen');

var _getPopOpenWelcomeMessage = require('./widgetDataSelectors/getPopOpenWelcomeMessage');

var _getIsMobile = require('../selectors/getIsMobile');

var _getPopMessageOnSmallScreens = require('./widgetDataSelectors/getPopMessageOnSmallScreens');

var _getInitialMessageText = require('./widgetDataSelectors/getInitialMessageText');

var _getAvailabilityAwayMessage = require('../availability/selectors/getAvailabilityAwayMessage');

var _getShouldHideWelcomeMessage = require('./getShouldHideWelcomeMessage');

var getShowInitialMessage = exports.getShowInitialMessage = (0, _reselect.createSelector)([_getPopOpenWelcomeMessage.getPopOpenWelcomeMessage, _getPopMessageOnSmallScreens.getPopMessageOnSmallScreens, _getInitialMessageText.getInitialMessageText, _getAvailabilityAwayMessage.getAvailabilityAwayMessage, _getIsOpen.getIsOpen, _getIsMobile.getIsMobile, _getShouldHideWelcomeMessage.getShouldHideWelcomeMessage], function (popOpenWelcomeMessage, popMessageOnSmallScreens, initialMessage, awayMessage, isOpen, isMobile, shouldHideWelcomeMessage) {
  if (shouldHideWelcomeMessage) {
    return false;
  }

  var popMessageOnMobile = Boolean(popMessageOnSmallScreens && isMobile);
  var popMessageOnDesktop = Boolean(popOpenWelcomeMessage && !isMobile);
  var popMessage = Boolean(popMessageOnDesktop || popMessageOnMobile);
  return Boolean(popMessage && !!initialMessage && !awayMessage && !isOpen);
});